module.exports = __webpack_public_path__ + "static/media/mortalkombat.3b629e51.jpg";